import { studentService } from '../services'
const initPropopsal ={
    name:null,
    keywords:['eyic2022-24'],
    introduction:null,
    lit_survey:null,
    software_req:null,
    hardware_req:null,
    implementation:null,
    feasibility:null,
    proposal_references:null,
}

export const student = {
    namespaced: true,
    state: {
        all: {},
        data: {},
        proposal:initPropopsal,
        loading: true,
        payment_done:false,
    },
    actions: {
         getStudentData({ dispatch,commit }) {
            commit('STUDENT_DATA_REQUEST')
             studentService.getStudentTeamMentor()
                .then( response => commit('STUDENT_DATA_SUCCESS', response),
                error => commit('STUDENT_DATA_FAILURE',{error}))
        },

        submitProposal({ dispatch,commit },data) {
             studentService.submitProposal(data)
                .then( response => commit('SUBMIT_PROPOSAL_SUCCESS', response),
                error => commit('SUBMIT_PROPOSAL_FAILURE',{error}))
        },



},
    mutations: {
        STUDENT_DATA_REQUEST(state) {
            state.loading = true
        },

        STUDENT_DATA_SUCCESS(state, data) {
            state.loading=false
            state.data=data
            if(data.proposal!=null && data.proposal != undefined){
                state.proposal=data.proposal
                state.proposal.keywords =data.proposal.keywords == null?initPropopsal.keywords:data.proposal.keywords.split(',')
            }
        },
        STUDENT_DATA_FAILURE(state, error) {
            state.all = { error }
            state.loading=false
        },
        TEAM_ID_FETCH_SUCCESS(state, teamId) {
            state.all={teamId}
            state.loading=false
        },
        TEAM_ID_FETCH_FAILURE(state, error) {
            state.all = { error }
            state.loading=false
        },
        SUBMIT_PROPOSAL_SUCCESS(state,data){
            state.all= {data}
        },
        SUBMIT_PROPOSAL_FAILURE(state,error){
            state.all= {error}
        },
        
        
    }
}
